import { Button } from "@mui/material";
import { dateFormatter } from "components/helpers";
import React from "react";
import { getFormattedDate } from "utils/helper";

export const columns = (handleViewDetails, handleOpenResetPassword) => {
  return [
    {
      field: "viewDetails",
      headerName: "Details",
      width: 120,
      renderCell: (params) => (
        <Button
          size="small"
          variant="text"
          onClick={() => handleViewDetails(params.row)}
        >
          View Details
        </Button>
      ),
    },
    { field: "user_id", headerName: "Email", width: 250 },
    {
      field: "user_name",
      headerName: "User Name",
      width: 200,
    },
    {
      field: "user_role",
      headerName: "User Role",
      width: 200,
    },
    {
      field: "status",
      headerName: "Status",
      width: 200,
    },
    {
      field: "resetPassword",
      headerName: "Actions",
      width: 160,
      renderCell: (params) => (
        <Button
          size="small"
          variant="outlined"
          color="warning"
          onClick={() => handleOpenResetPassword(params.row)}
        >
          Reset Password
        </Button>
      ),
    },
  ];
};

export const detailsColumns = (handleOpenDetailsModal) => {
  return [
    {
      field: "viewDetails",
      headerName: "Details",
      width: 120,
      renderCell: (params) => (
        <Button
          size="small"
          variant="text"
          onClick={() => handleOpenDetailsModal(params.row)}
        >
          View
        </Button>
      ),
    },
    { field: "user_id", headerName: "Email", width: 250 },
    {
      field: "first_name",
      headerName: "Name",
      width: 200,
      renderCell: (e) => <div>{`${e.value} ${e.row.last_name}`}</div>,
    },
    { field: "user_name", headerName: "User Name", width: 200 },
    { field: "phone_number", headerName: "Phone Number", width: 200 },
    {
      field: "created_date",
      headerName: "Created Date",
      width: 200,
      valueFormatter: (value) => (value ? getFormattedDate(value) : ""),
      valueGetter: (value) => dateFormatter(value),
    },
    { field: "user_role", headerName: "Role", width: 120 },
    { field: "status", headerName: "Status", width: 120 },
  ];
};
